import { globals, page as pageIndex } from "../../globals";
import { logOut } from "./auth";
import { showModal } from "./modal";
import { UPDATE_DATA, actionHandler } from "./updateData";


// ------------------------------------
// Constants
// ------------------------------------
export const GET_LEGSESSIONS_START = "GET_LEGSESSIONS_START";
export const GET_LEGSESSIONS_FAILURE = "GET_LEGSESSIONS_FAILURE";
export const GET_LEGSESSIONS_SUCCESS = "GET_LEGSESSIONS_SUCCESS";

export const RETURN_LEGSESSIONS_INITIAL_STATE = "RETURN_LEGSESSIONS_INITIAL_STATE";

export const SET_LEGSESSIONS_UPDATECODE_START = "SET_LEGSESSIONS_UPDATECODE_START"
export const SET_LEGSESSIONS_UPDATECODE_SUCCESS = "SET_LEGSESSIONS_UPDATECODE_SUCCESS";
export const SET_LEGSESSIONS_UPDATECODE_FAILURE = "SET_LEGSESSIONS_UPDATECODE_FAILURE";

export function getSessionsQuery(instruction, content) {
  return (dispatch) => {
    dispatch({ type: GET_LEGSESSIONS_START });

    const headers = {
      "Content-Type": "application/json",
    };

    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify({
        Instruction: instruction,
        Content: content,
      }),
    };

    return fetch(`${globals.apiUrl}/legsessions/querySessions`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_LEGSESSIONS_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_LEGSESSIONS_SUCCESS, 
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_LEGSESSIONS_FAILURE,
          json: err.message,
        });
      });
  };
}

export function toggleUpdateCode(updateCode, shortName, session){
  return (dispatch) => {
    dispatch({ type: SET_LEGSESSIONS_UPDATECODE_START });

    const headers = {
      "Content-Type": "application/json",
    };

    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify({
        UpdateCode: updateCode, 
        ShortName: shortName, 
        Session: session,
      }),
    };

    return fetch(`${globals.apiUrl}/legsessions/updateCode`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: SET_LEGSESSIONS_UPDATECODE_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: SET_LEGSESSIONS_UPDATECODE_SUCCESS, 
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: SET_LEGSESSIONS_UPDATECODE_FAILURE,
          json: err.message,
        });
      });
  };
}

export function returnInitialState() {
  return {
    type: RETURN_LEGSESSIONS_INITIAL_STATE,
  };
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UPDATE_DATA]: (state, action) =>
    action.location.page !== pageIndex.legSessions
      ? state
      : actionHandler(state, action),
  [RETURN_LEGSESSIONS_INITIAL_STATE]: () => {
    return {
      ...initialState,
    };
  },
  [GET_LEGSESSIONS_START]: (state) => {
    return {
      ...state,
    };
  },
  [GET_LEGSESSIONS_SUCCESS]: (state, action) => {
    const recordInfo = action.payload.json;
    return {
      ...state,
      sessions: recordInfo,
      formDataValue: {
        ...state.formDataValue,
        LSS: {
          ...state.formDataValue.LSS,
          sessions: recordInfo,
        },
      },
    };    
  },
  [GET_LEGSESSIONS_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [SET_LEGSESSIONS_UPDATECODE_START]: (state) => {
    return {
      ...state,
    };
  },
  [SET_LEGSESSIONS_UPDATECODE_SUCCESS]: (state, action) => {
    const recordInfo = action.payload.json;
    return {
      ...state,
      //sessions: recordInfo,
      formDataValue: {
        ...state.formDataValue,
        LSS: {
          ...state.formDataValue.LSS,
          //sessions: recordInfo,
        },
      },
    };    
  },
  [SET_LEGSESSIONS_UPDATECODE_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  errorCode: "",
  isFetchingData: false,
  renderData: {},
  formDataValue: {
    LSS: {},
  },
};

export default function legSessionsReducer(
  state = initialState,
  action
) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/reducers/legSessionsFormData.js